import { defaultCredentialingRoutes } from '@juvare/credentialing/backend/constants';
import { CredentialingConfig } from '@juvare/credentialing/backend/extraTypes';

export const credentialingConfig: CredentialingConfig = {
    credentialingRoutes: defaultCredentialingRoutes,
};
